import { useState, useEffect } from 'react';
import { AppState, AppStateStatus } from '../web/react-native';

interface UseAppStateProps {
  didBecomeActive?: () => void;
  didEnterForeground?: () => void;
  didEnterBackground?: () => void;
  onChange?: (nextState: AppStateStatus) => void;
}

const useAppState = (props: UseAppStateProps) => {
  const { didBecomeActive, didEnterForeground, didEnterBackground, onChange } = props;
  const [appState, setAppState] = useState(AppState.currentState);

  useEffect(() => {
    const appStateChangeHandler = (nextState: AppStateStatus) => {
      if (nextState === 'active' && appState === 'inactive') {
        didBecomeActive?.();
      } else if (nextState === 'active' && appState === 'background') {
        didBecomeActive?.();
        didEnterForeground?.();
      } else if (appState === 'active' && nextState.match(/background|inactive/)) {
        didEnterBackground?.();
      }
      setAppState(nextState);
      onChange?.(nextState);
    };
    const subscription = AppState.addEventListener('change', appStateChangeHandler);

    return () => subscription.remove();
  }, [onChange, didBecomeActive, didEnterForeground, didEnterBackground, appState]);

  return { appState };
};

export default useAppState;
